import logo from "../assets/logo.png";
import logoWebsite from "../assets/logosite.png";
import villa1 from "../assets/house1.jpg";
import villa2 from "../assets/house12.jpg";
import villa3 from "../assets/villa2.jpg";
import villa4 from "../assets/house14.jpg";
import villa5 from "../assets/house4.jpg";
import villa6 from "../assets/house9.jpg";
import villa7 from "../assets/house10.jpg";
import villa8 from "../assets/villa2.jpg";
import villa9 from "../assets/house16.jpg";
import villa10 from "../assets/house17.jpg";
import villa11 from "../assets/house8.jpg";
import villa12 from "../assets/house7.jpg";
import apartment1 from "../assets/villa5.jpg";
import apartment2 from "../assets/villa1.jpg";
import apartment3 from "../assets/villa4.jpg";
import house1 from "../assets/house3.jpg";
import house2 from "../assets/house13.jpg";
// import house16 from "../asset/house16.jpg";
import btm1 from "../assets/house15.jpg";
import btm2 from "../assets/house6.jpg";
import building from "../assets/building.jpg";
import building1 from "../assets/building1.jpg";
import building2 from "../assets/building2.jpg";
import building3 from "../assets/building3.jpg";
import building4 from "../assets/building4.jpg";
import building5 from "../assets/building5.jpg";
import building6 from "../assets/building6.jpg";
import building7 from "../assets/building7.jpg";
import building8 from "../assets/building8.jpg";
import building9 from "../assets/building9.jpg";
import building10 from "../assets/building10.jpg";
import building11 from "../assets/building11.jpg";
import building12 from "../assets/building12.jpg";
import building13 from "../assets/building13.jpg";
import building14 from "../assets/building14.jpg";
import building15 from "../assets/building15.jpg";
import building16 from "../assets/building16.jpg";
import building17 from "../assets/building17.jpg";
import building18 from "../assets/contactimg.jpg";
import plan1 from "../assets/1plan.jpg";
import plan2 from "../assets/2plan.jpg";
import plan3 from "../assets/3plan.jpg";
import plan4 from "../assets/4plan.jpg";
import plan5 from "../assets/5plan.jpg";
import plan6 from "../assets/6plan.jpg";
import plan7 from "../assets/7plan.jpg";
import plan8 from "../assets/8plan.jpg";
import service1 from "../assets/service1.jpg";
import service2 from "../assets/service2.jpg";
import service3 from "../assets/service3.jpg";
import boss from "../assets/boss.jpg";
import team from "../assets/team.jpg";
import team2 from "../assets/oob.jpg";
import office from "../assets/image3.jpg";
import place1 from "../assets/contact1.png";
import place2 from "../assets/contact2.png";
import place3 from "../assets/restaurant.jpg";
import travaux1 from "../assets/travaux1.jpg";
import travaux2 from "../assets/travaux2.jpg";
import travaux3 from "../assets/travaux3.jpg";
import travaux4 from "../assets/travaux4.jpg";
import travaux5 from "../assets/travaux5.jpg";
import travaux6 from "../assets/travaux6.jpg";
import travaux7 from "../assets/travaux7.jpg";
import travaux8 from "../assets/travaux8.jpg";
import travaux9 from "../assets/travaux9.jpg";
import travaux10 from "../assets/travaux10.jpg";
import travaux11 from "../assets/travaux11.jpg";
import travaux12 from "../assets/travaux12.jpg";
import travaux13 from "../assets/travaux13.jpg";
import travaux14 from "../assets/travaux14.jpg";
import travaux15 from "../assets/travaux15.jpg";
import travaux16 from "../assets/travaux16.jpg";

const images = {
  logo,
  logoWebsite,
  villa1,
  villa2,
  villa3,
  villa4,
  villa5,
  villa6,
  villa7,
  villa8,
  villa9,
  villa10,
  villa11,
  villa12,
  apartment1,
  apartment2,
  apartment3,
  house1,
  house2,
  // house16,
  btm1,
  btm2,
  building,
  building1,
  building2,
  building3,
  building4,
  building5,
  building6,
  building7,
  building8,
  building9,
  building10,
  building11,
  building12,
  building13,
  building14,
  building15,
  building16,
  building17,
  building18,
  plan1,
  plan2,
  plan3,
  plan4,
  plan5,
  plan6,
  plan7,
  plan8,
  service1,
  service2,
  service3,
  boss,
  team,
  team2,
  office,
  place1,
  place2,
  place3,
  travaux1,
  travaux2,
  travaux3,
  travaux4,
  travaux5,
  travaux6,
  travaux7,
  travaux8,
  travaux9,
  travaux10,
  travaux11,
  travaux12,
  travaux13,
  travaux14,
  travaux15,
  travaux16,
};

export default images;
